import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { groupByMonth, getLimitDate, getDateLabels, countList, sumList, firstYear, yearsListOption } from '../../utils/statsFunctions';

import HighChartStack from './Charts/HighChartStack';
import { Card, Grid, Box } from '@mui/material';
import { InputSelectNative } from '../common/Form';
import { hex2rgba } from '../Admin/Budget/BudgetSingle';
import Currency from '../common/Currency';


class StackedStats extends Component {
    state = { 
        year: this.props.budget_year || new Date().getFullYear(),
    }

    filterList = () => {
        const { SPENDINGS } = this.props;
  
        let dateLimit = getLimitDate("year", this.state.year)
        let endYear = parseInt(this.state.year)+1
        console.log('====================================');
        console.log({dateLimit, endDate : new Date(endYear, 0, 1)});
        console.log('====================================');
        let list = Object.values(SPENDINGS).filter( item => 
            new Date(item.spending_date) > dateLimit &&
            new Date(item.spending_date) < new Date(endYear, 0, 1)
        )

        let nbPerCatlist = countList(list, "spending_category")
        let topCats = Object.keys(nbPerCatlist).sort( (a, b) => nbPerCatlist[b] - nbPerCatlist[a])

        return {list, topCats}
    }
    calcData = () => {
        const { CATEGORIES } = this.props;
        let sum = {}
        let series = []
        let bckg = []
        let average = []
        let formatted = {}
        let alpha = 80
        let total = 0

        let info = this.filterList()
        
        let list = info.list
        let catList = info.topCats
        let dateLabels = getDateLabels("year", this.state.year)
        let categories = groupByMonth(list, "spending_date")
        // let categories = this.props.filter_period === "year" ? groupByMonth(list, "spending_date") : groupByDate(list, "spending_date")

        dateLabels.forEach( date => {
            sum[date] = categories[date] ? sumList(categories[date], "spending_category", "spending_amount") : {}
            if (this.props.budget_max) {
                average.push(this.props.budget_max/12)
            }
        })
        
     
        catList.forEach(cat => {
            Object.values(sum).forEach( data => {
                if(!formatted[cat]){
                    formatted[cat] = []
                }
                formatted[cat].push(data[cat] || 0)
            })
        })
        Object.keys(formatted).forEach( catID => {
            series.push({
                name: !isEmpty(CATEGORIES) && CATEGORIES[catID] && 
                    `${CATEGORIES[catID].category_name}`,
                data: formatted[catID],
            })

            total += formatted[catID].reduce((prev, curr) => prev + curr )

            if (bckg.includes(CATEGORIES[catID].category_color)) {
                let alphaStr = "."+alpha
                let color = hex2rgba(CATEGORIES[catID].category_color, alphaStr)
                bckg.push(color)
                
                alpha = alpha >= 40 ? alpha - 20 : alpha
            } else {
                bckg.push(CATEGORIES[catID].category_color)
            }
        })
            
        if (this.props.budget_max) {
            series.push({
                type: 'spline',
                name: 'Budget',
                data: average,
                marker: {
                    lineWidth: 2,
                    lineColor: "gold",
                    // lineColor: Highcharts.getOptions().colors[3],
                    fillColor: 'white'
                }
            })
        }
 
        console.log('====================================');
        console.log({categories, series, bckg, sum, formatted, list});
        console.log('====================================');
        return {categories : dateLabels, series, bckg, total}
    }

    render() {
        const { SPENDINGS, CATEGORIES, noDateFilter } = this.props;
        let info_stack = !isEmpty(SPENDINGS) && !isEmpty(CATEGORIES) ? this.calcData() : {}
        
        return (
            <Box>
                Total: <Currency value={info_stack.total} />

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box p={2}>
                            {!noDateFilter &&
                                <InputSelectNative
                                    labelWidth={60}
                                    onChange={ (e) => this.setState({ year: e.target.value })}
                                    value={this.state.year}
                                    label="Année"
                                    options={yearsListOption()}
                                    // options={[
                                    //     <option>{new Date().getFullYear()}</option>,
                                    //     <option>{firstYear}</option>
                                    // ]}
                                />
                            }
                        </Box>
                        <Card>
                            <HighChartStack 
                                title={`Dépenses ${this.state.year} Par Catégorie`}
                                titleY="Montant FCFA"
                                type="column"
                                categories={info_stack.categories}
                                series={info_stack.series}
                                legend={false}
                                colors={info_stack.bckg}
                            />
                            
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default StackedStats;

